import { createAsyncThunk } from '@reduxjs/toolkit'
import { Document } from '../../types/documentTypes'
import { getDocumentById, getDocumentsByFolder } from '../../api/documentApi'
import { handleError } from '../../utils/errorHandler'

export const fetchDocumentById = createAsyncThunk<
  Document,
  string,
  { rejectValue: string }
>('document/fetchById', async (id, thunkAPI) => {
  try {
    const response = await getDocumentById(id)
    console.log('response doc', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const fetchDocumentsByFolder = createAsyncThunk<
  Document[],
  string,
  { rejectValue: string }
>('document/fetchByFolder', async (folder, thunkAPI) => {
  try {
    const response = await getDocumentsByFolder(folder)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
